import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    const authHeader = error.config?.headers?.Authorization;
    const isAdminEndpoint = requestUrl.includes('/admin');
    const hasAuthHeader = Boolean(authHeader);

    if (status === 401 && (isAdminEndpoint || hasAuthHeader)) {
      localStorage.removeItem('token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Image APIs
export const getImages = async (params = {}) => {
  const response = await api.get('/images', { params });
  return response.data;
};

export const getImage = async (id) => {
  const response = await api.get(`/images/${id}`);
  return response.data;
};

export const uploadImage = async (formData) => {
  const response = await api.post('/images', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updateImage = async (id, data) => {
  const response = await api.put(`/images/${id}`, data);
  return response.data;
};

export const deleteImage = async (id) => {
  const response = await api.delete(`/images/${id}`);
  return response.data;
};

// Category APIs
export const getCategories = async () => {
  const response = await api.get('/categories');
  return response.data;
};

export const createCategory = async (data) => {
  const response = await api.post('/admin/categories', data);
  return response.data;
};

export const updateCategory = async (id, data) => {
  const response = await api.put(`/admin/categories/${id}`, data);
  return response.data;
};

export const deleteCategory = async (id) => {
  const response = await api.delete(`/admin/categories/${id}`);
  return response.data;
};

// Contact APIs
export const submitContact = async (data) => {
  const response = await api.post('/contact', data);
  return response.data;
};

export const getContacts = async () => {
  const response = await api.get('/admin/contacts');
  return response.data;
};

export const markContactRead = async (id) => {
  const response = await api.put(`/admin/contacts/${id}/read`);
  return response.data;
};

export const deleteContact = async (id) => {
  const response = await api.delete(`/admin/contacts/${id}`);
  return response.data;
};

export default api;
